import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Row } from "antd";
import moment from "moment";

import orderApi from "../../apis/Order.api";
import { setLoading } from "../../redux/store/common/commonDuck";
import ApiService from "../../utils/ApiService";

import SettlementCase from "./settlement/SettlementCase";
import SettlementInfo from "./settlement/SettlementInfo";
import SettlementMonth from "./settlement/SettlementMonth";

const api = new ApiService();
const ReportSettlementComponent = () => {
	const dispatch = useDispatch();

	const user = useSelector((state) => state.auth.user);
	const setIsLoading = (value) => dispatch(setLoading(value));
	const [serviceInfo, setServiceInfo] = useState(null);
	const [settlementList, setSettlementList] = useState([]);
	const [targetYear, setTargetYear] = useState("2023");
	const [targetMonth, setTargetMonth] = useState("1");

	const [subTitle, setSubTitle] = useState("month");
	const [orderTotalList, setOrderTotalList] = useState([]);
	const [orderLoading, setOrderLoading] = useState(false);

	// const pageSize = 10;
	// const [offset, setOffset] = useState(0)
	// const [totalSize, setTotalSize] = useState(0)

	// useEffect(() => {
	//     getSettlementList();
	// }, [offset]);

	/**
	 * 정산 목록 조회
	 */
	// const getSettlementList = async () => {
	//     setIsLoading(true);
	//     try {
	//         const param = {
	//             offset: offset,
	//             pageSize: pageSize,
	//             influencer_id: user.id
	//         }
	//         const res = await settlementApi.readSettlementList(param);
	//         // console.log("getSettlementList res", res)
	//         if (res.code === 200) {
	//             // setTotalSize(res.result.totalCnt)
	//             setSettlementList(res.result.settlementList)
	//         }
	//         setIsLoading(false);
	//     } catch (error) {
	//         setIsLoading(false);
	//         alert(error)
	//     }
	// }
	useEffect(() => {
		setTargetYear(moment().subtract(1, "month").format("YYYY"));
		setTargetMonth(moment().subtract(1, "month").format("M"));
	}, []);

	useEffect(() => {
		if (targetYear && targetMonth) {
			getOrderList();
		}
	}, [targetMonth, targetYear]);

	const getOrderList = async () => {
		setIsLoading(true);
		setOrderLoading(true);
		const linkParam = {
			userId: user?.id,
		};
		const linkRes = await api.getProductLinkList(linkParam);
		if (linkRes.data.code === 200 && linkRes.data.result?.length) {
			setIsLoading(true);
			const linkList = linkRes.data.result.map((link) => link.query);
			const query = linkList.join(",");
			const param = {
				startDate: moment(
					`${targetYear}-${targetMonth < 10 ? "0" + targetMonth : targetMonth}`
				)
					.startOf("month")
					.format("YYYYMMDDHHmm"),
				endDate: moment(
					`${targetYear}-${targetMonth < 10 ? "0" + targetMonth : targetMonth}`
				)
					.endOf("month")
					.format("YYYYMMDDHHmm"),
				queryList: query,
				orderType: "complete_date",
				orderBy: "desc",
				pageType: "settlement",
				influencerId: user?.id,
			};
			// console.log("targetYear && targetMonth", param, moment(`${targetYear}-${targetMonth < 10 ? "0" + targetMonth : targetMonth}`).startOf("month").format("YYYYMMDDHHmm"), targetYear,targetMonth);
			const res = await orderApi.orderByInfluencer(param);
			if (res.code === 200) {
				// console.log(res.result.userOrderDetailDTOList, param);
				// 구매확정 일자로 정렬 - 건별
				setOrderTotalList(
					res.result.userOrderDetailDTOList.sort(
						(a, b) => moment(b.complete_date) - moment(a.complete_date)
					)
				);
				// 월별
				setSettlementList(res.result?.partnersSettlementList ?? []);
				setServiceInfo(res.result?.partnersServiceInfo);
				setIsLoading(false);
			} else {
				setIsLoading(false);
			}
		} else {
			setIsLoading(false);
		}
		setOrderLoading(false);
	};
	return (
		<>
			{/*<p className="report-settlement-title">실적 발생일 기준 익월 25일에 업데이트 됩니다.</p>*/}
			<Row justify={"center"} className={`report-settlement-row`}>
				<Button
					onClick={() => setSubTitle("month")}
					className={`${subTitle === "month" ? "click" : ""}`}
					size={`large`}
				>
					월별 정산
				</Button>
				<Button
					onClick={() => setSubTitle("case")}
					className={`${subTitle === "case" ? "click" : ""}`}
					size={`large`}
				>
					건별 정산
				</Button>
			</Row>
			{subTitle === "month" ? (
				<SettlementMonth
					settlementList={settlementList}
					targetYear={targetYear}
					setTargetYear={setTargetYear}
					targetMonth={targetMonth}
					setTargetMonth={setTargetMonth}
					getOrderList={getOrderList}
					orderLoading={orderLoading}
					serviceInfo={serviceInfo}
				/>
			) : (
				<SettlementCase
					targetYear={targetYear}
					setTargetYear={setTargetYear}
					targetMonth={targetMonth}
					setTargetMonth={setTargetMonth}
					orderTotalList={orderTotalList}
					orderLoading={orderLoading}
				/>
			)}
			<SettlementInfo />
		</>
	);
};

export default ReportSettlementComponent;
